function initSlideshowTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initCartTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initMarqueeTimer(targetDate, targetClass) {
    startNewTimer(targetDate, targetClass);
  }
function initProductTimer(targetDate, targetClass) {
    startNewTimer(targetDate,targetClass);
  }
  
function startNewTimer(targetDate,targetClass) {
  const targetTime = new Date(targetDate).getTime();
  const timers = document.querySelectorAll(targetClass);

  function updateNewTimer() {
    const currentTime = new Date().getTime();
    const timeDifference = targetTime - currentTime;

    let days = 0, hours = 0, minutes = 0, seconds = 0;

    if (timeDifference > 0) {
      days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    }

    timers.forEach(timer => {
      const daysEl = timer.querySelector('.timer-mdays');
      const hoursEl = timer.querySelector('.timer-mhours');
      const minutesEl = timer.querySelector('.timer-mminutes');
      const secondsEl = timer.querySelector('.timer-mseconds');

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    });
  }

  updateNewTimer();
  const mtimerInterval = setInterval(updateNewTimer, 1000);

  document.addEventListener('shopify:section:unload', () => clearInterval(mtimerInterval));
}

  
function initAnnouncementTimer(targetDate) {
    startTimer(targetDate);
  }
  
  function startTimer(targetDate) {
    const daysElement = document.getElementById('days');
    const hoursElement = document.getElementById('hours');
    const minutesElement = document.getElementById('minutes');
    const secondsElement = document.getElementById('seconds');
  
    const targetTime = new Date(targetDate).getTime();
  
    if (daysElement && hoursElement && minutesElement && secondsElement) {
      function updateTimer() {
        const currentTime = new Date().getTime();
        const timeDifference = targetTime - currentTime;
  
        if (timeDifference <= 0) {
          daysElement.textContent = "00";
          hoursElement.textContent = "00";
          minutesElement.textContent = "00";
          secondsElement.textContent = "00";
          return;
        }
  
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
  
        daysElement.textContent = String(days).padStart(2, '0');
        hoursElement.textContent = String(hours).padStart(2, '0');
        minutesElement.textContent = String(minutes).padStart(2, '0');
        secondsElement.textContent = String(seconds).padStart(2, '0');
      }
  
      updateTimer();
      const timerInterval = setInterval(updateTimer, 1000);
  
      document.addEventListener('shopify:section:unload', () => clearInterval(timerInterval));
    }
  }
  
function initmslideshowswiper(autoPlay, time) {
  var swiper = new Swiper(".mslideshowswiper", {
    loop: true,
    autoplay: autoPlay ? {
      delay: parseInt(time) || 7000,  // Fallback to 7000 if time is invalid
      disableOnInteraction: true,
    } : false, // Disable autoplay if autoPlay is false
    speed: 1000,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}



function toggleChat() {
    const chatHost = document.querySelector('#shopify-chat inbox-online-store-chat');
    
    if (chatHost && chatHost.shadowRoot) {
        const button = chatHost.shadowRoot.querySelector('button'); // Change this to the specific button selector if needed
        if (button) {
            button.click(); // Simulate button click
        } 
    }
}


document.addEventListener('DOMContentLoaded', () => {
        const updateFilterPosition = () => {
            const header = document.querySelector('.section-header');
            const filters = document.querySelector('#main-collection-filters');
          if (header && filters){
            const headerHeight = header.offsetHeight - 2;
            filters.style.top = `${headerHeight}px`;
          }
        };

        // Update on scroll
        window.addEventListener('scroll', updateFilterPosition);

        // Initial update in case scroll doesn't occur
        updateFilterPosition();
   
});

 document.addEventListener("DOMContentLoaded", function() {
      let headings = document.getElementsByClassName("mcollapse-heading");
      for (let i = 0; i < headings.length; i++) {
          headings[i].addEventListener("click", function() {
              this.classList.toggle("active");
              let content = this.nextElementSibling;
              if (content && content.classList.contains("mcollapse-content")) {
                  if (content.style.maxHeight) {
                      content.style.maxHeight = null;
                  } else {
                      content.style.maxHeight = content.scrollHeight + "px";
                  }
              }
          });
      }
  });

// Handle #magree checkbox
var magreeCheckbox = document.getElementById('magree');
if (magreeCheckbox) {
    magreeCheckbox.addEventListener('change', function() {
        var cartDrawerCheckout = document.querySelector('.mcart-drawer-checkout');
        if (cartDrawerCheckout) {
            if (this.checked) {
                cartDrawerCheckout.classList.remove('mnotchecked');
            } else {
                cartDrawerCheckout.classList.add('mnotchecked');
            }
        }
    });
}

// Handle #agree checkbox
var agreeCheckbox = document.getElementById('agree');
if (agreeCheckbox) {
    agreeCheckbox.addEventListener('change', function() {
        var checkoutButton = document.getElementById('checkout');
        if (checkoutButton) {
            checkoutButton.disabled = !this.checked;
        }
    });
}

function initAnnouncementStickiness() {
  let lastScrollY = window.scrollY;

  function isElementMovedUpAndOutOfViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom <= 0 && rect.top < window.innerHeight;
  }

  function checkVisibility() {
    const ogPaymentElement = document.querySelector(".M-sticky-announcement-target");
    const stickyatc = document.querySelector(".msticky-announcement");

    if (!ogPaymentElement || !stickyatc) return;

    const currentScrollY = window.scrollY;

    const scrollingDown = currentScrollY > lastScrollY;

    if (scrollingDown && isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mannouncement-sticky");
    } else if (!scrollingDown) {
      stickyatc.classList.remove("mannouncement-sticky");
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility);
  checkVisibility();
}

function checkAndPlayVideo() {
    var videos = document.querySelectorAll(".mproduct-video");
    
    // Only proceed if there's at least one video
    if (videos.length === 0) return;

    videos.forEach(function(video) {
        if (video.paused) {
            video.play();
            console.log("Video was paused. Resuming playback.");
        }
    });
}

setInterval(checkAndPlayVideo, 1000);

document.addEventListener('DOMContentLoaded', () => {
  // Only run this on mobile (optional)
  if (window.innerWidth <= 768) { // Adjust breakpoint as needed
    document.querySelectorAll('[id^="Details-"].mcollapse').forEach((detailsEl) => {
      detailsEl.removeAttribute('open');
    });

    document.querySelectorAll('[id^="Details-"].mcollapse summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
    });
  }
});
